define('StoreLocator.List.View.Extension', [
  'StoreLocator.List.View',
  'underscore',
  'Profile.Model',
  'Ames.HomeStore.HomeStore.SS2Model',
  'Environment',
], function defineAddressDetailsView(
  StoreLocatorListView,
  _,
  ProfileModel,
  HomeStoreModel,
  Environment
) {
  'use strict';
  _.extend(StoreLocatorListView.prototype, {
    events: {
      'mouseover li': 'openMapInfoWindow',
      'click [data-action="set-home-store"]': 'setHomeStore'
    },
    initialize: _.wrap(StoreLocatorListView.prototype.initialize, function (fn) {
      fn.apply(this, _.toArray(arguments).slice(1));
      this.homeStoreModel = new HomeStoreModel();
      this.isRentalTools = true;
      this.closeMsg = '';
      var self = this;
      this.homeStoreModel.fetch({
        data: {
          locationId: this.model.get('internalid')
        }
      }).done(function(resp) {
        self.isRentalTools = resp.isRentalTools;
        if (resp.closedMsg) {
          self.closeMsg = resp.closedMsg;
        }
        self.render();
      });
    }),
    setHomeStore: function setHomeStore(e) {
      e.preventDefault();
      e.stopPropagation();
      var storeId = e.currentTarget.id;
      storeId = storeId.replace('store-', '');
      var self = this;
      this.homeStoreModel.save({
        data: {
          storeId: storeId
        }
      }).done(function () {
        var Application = Environment.Environment.getApplication();
        var layout = Application.getLayout();
        layout.showConfirmationMessage('Home store has been set successfully.');
        // if its display none, then show it
        if ($('.usermgmt-list-confirm-message').css('display') === 'none') {
          self.$('.usermgmt-list-confirm-message').show();
        }

        setTimeout(function () {
          $('.usermgmt-list-confirm-message').show();
        }, 1000);
        
      });
    },
    getContext: _.wrap(StoreLocatorListView.prototype.getContext, function (fn) {
      var context = fn.apply(this, _.toArray(arguments).slice(1));
      context.showHomeStore = ProfileModel.getInstance().get('isLoggedIn') === 'T';
      context.isRentalTools = this.isRentalTools;
      context.storeMsg = this.closeMsg;
      return context;
    }),
  });
});
